module.exports = __webpack_public_path__ + "static/media/1016001BE.f2441fd6.jpg";